import React from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

export type AddNoteScreenOwnProps = {};

export type AddNoteScreenProps = AddNoteScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'add-note'>;
};

const AddNoteScreen: React.FC<AddNoteScreenProps> = (props) => {
    const goBack = useGoBack();
    const { isCreatingNote, noteEditorProps, key } = useEditNote({
        noteDestination: props.route.params,
        onCreationSuccess: () => {
            goBack();
        },
    });

    const profileId =
        props.route.params.entityType === 'user' ||
        props.route.params.entityType === 'organization' ||
        props.route.params.entityType === 'organization-client-record'
            ? null
            : props.route.params.medicalProfileId;

    const editor = (
        <NotesEditor
            key={key}
            source="profiles.add-note-route"
            onCancel={() => goBack()}
            isDisabled={isCreatingNote}
            noteDestination={props.route.params}
            defaultOpenAttachmentType={props.route.params.defaultOpenAttachmentType}
            {...noteEditorProps}
        />
    );

    return (
        <AnimateLoadedContent isLoading={isCreatingNote}>
            {() =>
                profileId ? (
                    <ProfileHeaderContainer profileId={profileId} omitChatButton>
                        {editor}
                    </ProfileHeaderContainer>
                ) : (
                    editor
                )
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(AddNoteScreen);
